// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 10/10/2023
 */


.containerOne_redBoxTop__Wv3Pc{
  position: relative;
  padding: 2.5rem 1.25rem;
  border-radius: 0.5rem;
  background: #002566;
  box-shadow: 0px 4px 20px 0px rgba(50, 50, 71, 0.04), 0px 4px 4px 0px rgba(0, 0, 0, 0.01);
  color: #FFF;
  width: 36rem;
  margin: 1rem auto;
  margin-bottom: 6rem;
  max-width: 50rem;
  z-index: 2;
}

.containerOne_redBoxBottom__GOd98 {
  position: relative;
  padding: 2.5rem 1.25rem;
  border-radius: 0.5rem;
  background: #002566;
  box-shadow: 0px 4px 20px 0px rgba(50, 50, 71, 0.04), 0px 4px 4px 0px rgba(0, 0, 0, 0.01);
  color: #FFF;
  width: 36rem;
  margin: 1rem;
  max-width: 50rem;
  left: 0;
  z-index: 2;
}

.containerOne_title__X8-mq {
  font-size: 1.5rem;
  padding-bottom: 1rem;
}

.containerOne_description__2HLJV {
  font-size: 1rem;
}

.containerOne_imageContainer__5O71F {
  position: absolute;
  right: 5%;
  padding-bottom: 5rem;
  margin-top: 10rem;
}

.containerOne_image__Vzi8L {
  position: relative;
  z-index: 2;
}

/* mobile screen */
@media (max-width: 770px) {
  .containerOne_title__X8-mq {
    font-size: 1rem;
    padding-bottom: 1rem;
  }

  .containerOne_description__2HLJV {
    font-size: 0.75rem;
  }
  .containerOne_image__Vzi8L {
    height: 14rem;
    /* width: 12rem; */
  }

  .containerOne_redBoxTop__Wv3Pc{
    padding: 1rem 1.25rem;
    width: 17rem;
    right: 0;
  }
  .containerOne_redBoxBottom__GOd98 {
    padding: 1rem 1.25rem;
    width: 17rem;
    margin-top: 14rem;
    left: 0;
  }
}

@media (min-width: 1450px) {
  .containerOne_imageContainer__5O71F {
    position: absolute;
    right: 15%;
    padding-bottom: 5rem;
    margin-top: 10rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/aboutUs/containerOne.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;EAoBE;;;AAGF;EACE,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;EACrB,mBAAmB;EACnB,wFAAwF;EACxF,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;EACrB,mBAAmB;EACnB,wFAAwF;EACxF,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,OAAO;EACP,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA,kBAAkB;AAClB;EACE;IACE,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,YAAY;IACZ,QAAQ;EACV;EACA;IACE,qBAAqB;IACrB,YAAY;IACZ,iBAAiB;IACjB,OAAO;EACT;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,UAAU;IACV,oBAAoB;IACpB,iBAAiB;EACnB;AACF","sourcesContent":["/*\r\n * Copyright (c) 2023 by N-Ach (Pvt) Ltd\r\n *\r\n * ╔═╗ ╔╗    ╔═══╗  ╔╗\r\n * ║║╚╗║║    ║╔═╗║  ║║\r\n * ║╔╗╚╝║    ║║ ║╠══╣╚═╗\r\n * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║\r\n * ║║ ║║║╚══╝║╔═╗║╚═╣║║║\r\n * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝\r\n *\r\n * All rights reserved.\r\n *\r\n * This software is the confidential and proprietary information\r\n * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential\r\n * Information and shall use it only in accordance with the terms\r\n * of the license agreement you entered into with N-Ach (Pvt) Ltd.\r\n *\r\n *\r\n * @Author Dilhari Jayathunga\r\n * @Date 10/10/2023\r\n */\r\n\r\n\r\n.redBoxTop{\r\n  position: relative;\r\n  padding: 2.5rem 1.25rem;\r\n  border-radius: 0.5rem;\r\n  background: #002566;\r\n  box-shadow: 0px 4px 20px 0px rgba(50, 50, 71, 0.04), 0px 4px 4px 0px rgba(0, 0, 0, 0.01);\r\n  color: #FFF;\r\n  width: 36rem;\r\n  margin: 1rem auto;\r\n  margin-bottom: 6rem;\r\n  max-width: 50rem;\r\n  z-index: 2;\r\n}\r\n\r\n.redBoxBottom {\r\n  position: relative;\r\n  padding: 2.5rem 1.25rem;\r\n  border-radius: 0.5rem;\r\n  background: #002566;\r\n  box-shadow: 0px 4px 20px 0px rgba(50, 50, 71, 0.04), 0px 4px 4px 0px rgba(0, 0, 0, 0.01);\r\n  color: #FFF;\r\n  width: 36rem;\r\n  margin: 1rem;\r\n  max-width: 50rem;\r\n  left: 0;\r\n  z-index: 2;\r\n}\r\n\r\n.title {\r\n  font-size: 1.5rem;\r\n  padding-bottom: 1rem;\r\n}\r\n\r\n.description {\r\n  font-size: 1rem;\r\n}\r\n\r\n.imageContainer {\r\n  position: absolute;\r\n  right: 5%;\r\n  padding-bottom: 5rem;\r\n  margin-top: 10rem;\r\n}\r\n\r\n.image {\r\n  position: relative;\r\n  z-index: 2;\r\n}\r\n\r\n/* mobile screen */\r\n@media (max-width: 770px) {\r\n  .title {\r\n    font-size: 1rem;\r\n    padding-bottom: 1rem;\r\n  }\r\n\r\n  .description {\r\n    font-size: 0.75rem;\r\n  }\r\n  .image {\r\n    height: 14rem;\r\n    /* width: 12rem; */\r\n  }\r\n\r\n  .redBoxTop{\r\n    padding: 1rem 1.25rem;\r\n    width: 17rem;\r\n    right: 0;\r\n  }\r\n  .redBoxBottom {\r\n    padding: 1rem 1.25rem;\r\n    width: 17rem;\r\n    margin-top: 14rem;\r\n    left: 0;\r\n  }\r\n}\r\n\r\n@media (min-width: 1450px) {\r\n  .imageContainer {\r\n    position: absolute;\r\n    right: 15%;\r\n    padding-bottom: 5rem;\r\n    margin-top: 10rem;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"redBoxTop": `containerOne_redBoxTop__Wv3Pc`,
	"redBoxBottom": `containerOne_redBoxBottom__GOd98`,
	"title": `containerOne_title__X8-mq`,
	"description": `containerOne_description__2HLJV`,
	"imageContainer": `containerOne_imageContainer__5O71F`,
	"image": `containerOne_image__Vzi8L`
};
export default ___CSS_LOADER_EXPORT___;
